// This ensures that the received function is only run once
const runOnce = functionToRun => {
  let hasRun = false;

  return (...args) => {
    if (hasRun) {
      return undefined;
    }

    hasRun = true;

    return functionToRun(...args);
  };
};

export default runOnce;
